/**
 * Reading `document.cookie`.
 *
 * A cookie value is allowed to contain `=`, so a name/value pair must be split on the *first*
 * `=` only. `pair.split('=')[1]` drops everything after the second `=` — that is how the
 * `_fbc` click id (`fb.<subdomainIndex>.<creationTime>.<fbclid>`) could reach Meta truncated.
 */

/** `decodeURIComponent` throws on a stray `%`; keep the raw value instead of losing the cookie. */
function decode(value: string): string {
  try {
    return decodeURIComponent(value)
  } catch {
    return value
  }
}

/**
 * Every value stored under `name`, in the order the browser reports them.
 *
 * The same name can be present more than once when the cookies were written on different
 * domain or path scopes, so callers that care must pick a value explicitly.
 */
export function getCookies(name: string): string[] {
  if (typeof document === 'undefined') return []

  const values: string[] = []

  for (const pair of document.cookie.split(';')) {
    const cookie = pair.trim()
    const separator = cookie.indexOf('=')

    if (separator === -1) continue
    if (cookie.slice(0, separator) !== name) continue

    values.push(decode(cookie.slice(separator + 1)))
  }

  return values
}

/** First value stored under `name`, or `undefined` when the cookie is not set. */
export function getCookie(name: string): string | undefined {
  return getCookies(name)[0]
}
